module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"error":"Não foi possível salvar o perfil","profile-saved":"Perfil salvo com sucesso"}}')
  delete Component.options._Ctor
}
